import React from 'react';
import _ from 'underscore';
import { Link } from 'react-router-dom';

import './NMOption.scss';

class NMOption extends React.Component {
  render() {
    const track = _.find(this.props.tracks, track => track.attributes.long_symbol === this.props.track_long_symbol);
    if (!track) { return null; }

    const immersiveOption = _.find(track.relationships.price_options.data, po => po.attributes.name === 'immersive');
    const personalizedOption = _.find(track.relationships.price_options.data, po => po.attributes.name === 'personalized');

    return (
      <Link to={`/enroll?track=${track.attributes.long_symbol}`} style={{ textDecoration: 'none' }} className='nm-card d-block hovercraft rounded'>
        <div className='d-flex justify-content-between header' ref={(c) => { this.header = c; }} style={{ backgroundColor: track.attributes.color }}>
          <div className="d-flex flex-column align-items-start justify-content-between">
            <span className='program'></span>
            <div className='nmLogo d-flex flex-column rounded align-items-center'>
              <h1 className='shortSymbol'>{track.attributes.short_name}</h1>
            </div>
          </div>

          <div className="d-flex flex-column align-items-end justify-content-between">
            <div className="d-flex flex-column">
              <span className='text-center nmAttr'>{track.attributes.num_of_courses} Courses</span>
            </div>

            <div className='d-flex justify-content-end flex-wrap nmAttrs'>
              {
                track.attributes.tags.map((tag, index) => (<div key={index}><span className="rounded">{tag}</span></div>))
              }
            </div>
          </div>
        </div>
        <div className='d-flex flex-column align-items-between info'>
          <h2 className="mb-2 mb-sm-3">
            <span className='dot rounded-circle d-inline-block' style={{backgroundColor: track.attributes.color}}></span>
            <span style={{fontSize: '80%'}}>{track.attributes.long_name}</span>
          </h2>

          <div style={{ fontSize: '0.9em' }}>
            <div className='d-flex justify-content-between option personalized'>
              <b>Personalized Career Path</b>
              <div> ${Math.round(personalizedOption.attributes.amount * this.props.rate)} </div>
            </div>

            <div className='d-flex justify-content-between option immersive'>
              <b>Immersive Path</b>
              <div> ${Math.round(immersiveOption.attributes.amount * this.props.rate)} </div>
            </div>

            <div className="text-right p-1"><i>or ${Math.round(immersiveOption.attributes.amount_installment * this.props.rate * 100) / 100}/month x 12</i></div>
          </div>

          {this.props.most_popular && (<h3 className="text-center d-md-none"><span className="badge badge-success px-3 py-2 rounded mt-2" style={{color: "#eceff1", backgroundColor: "#1647fb"}}>Most Popular</span></h3>)}
        </div>
      </Link>
    );
  }
}

export default NMOption;
